import React from 'react';
import SectionLayout from 'src/app/atoms/Layout/Section/SectionLayout';
import RankedG2 from 'src/app/organisms/Homepage/RankedG2/RankedG2';

const SocialProof = (): JSX.Element => {
  return (
    <SectionLayout
      maxWidth='width-3xl'
      padding={['spacing-7xl', 'spacing-4xl']}
      paddingSm={['spacing-4xl', 'spacing-xl']}
    >
      <RankedG2 />
    </SectionLayout>
  );
};

export default SocialProof;
